"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealNegotiationToJSON = exports.DealNegotiationFromJSONTyped = exports.DealNegotiationFromJSON = exports.instanceOfDealNegotiation = void 0;
var runtime_1 = require("../runtime");
var FrequencyCap_1 = require("./FrequencyCap");
var Targets_1 = require("./Targets");
/**
 * Check if a given object implements the DealNegotiation interface.
 */
function instanceOfDealNegotiation(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "priceFloorMicroAmount" in value;
    isInstance = isInstance && "targets" in value;
    isInstance = isInstance && "startTime" in value;
    isInstance = isInstance && "endTime" in value;
    return isInstance;
}
exports.instanceOfDealNegotiation = instanceOfDealNegotiation;
function DealNegotiationFromJSON(json) {
    return DealNegotiationFromJSONTyped(json, false);
}
exports.DealNegotiationFromJSON = DealNegotiationFromJSON;
function DealNegotiationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'category': !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
        'createdAt': (new Date(json['created_at'])),
        'priceFloorMicroAmount': json['price_floor_micro_amount'],
        'budgetMicroAmount': !(0, runtime_1.exists)(json, 'budget_micro_amount') ? undefined : json['budget_micro_amount'],
        'targets': (0, Targets_1.TargetsFromJSON)(json['targets']),
        'frequencyCaps': !(0, runtime_1.exists)(json, 'frequency_caps') ? undefined : (new Set(json['frequency_caps'].map(FrequencyCap_1.FrequencyCapFromJSON))),
        'startTime': (new Date(json['start_time'])),
        'endTime': (new Date(json['end_time'])),
        'acceptedAt': !(0, runtime_1.exists)(json, 'accepted_at') ? undefined : (new Date(json['accepted_at'])),
    };
}
exports.DealNegotiationFromJSONTyped = DealNegotiationFromJSONTyped;
function DealNegotiationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'description': value.description,
        'category': value.category,
        'created_at': (value.createdAt.toISOString()),
        'price_floor_micro_amount': value.priceFloorMicroAmount,
        'budget_micro_amount': value.budgetMicroAmount,
        'targets': (0, Targets_1.TargetsToJSON)(value.targets),
        'frequency_caps': value.frequencyCaps === undefined ? undefined : (Array.from(value.frequencyCaps).map(FrequencyCap_1.FrequencyCapToJSON)),
        'start_time': (value.startTime.toISOString()),
        'end_time': (value.endTime.toISOString()),
        'accepted_at': value.acceptedAt === undefined ? undefined : (value.acceptedAt.toISOString()),
    };
}
exports.DealNegotiationToJSON = DealNegotiationToJSON;
